module.exports = __webpack_public_path__ + "static/media/churchxBadge.5b58e0b8.svg";